<div style="margin-left: 20px;">
    <form [formGroup]="SettingsForm">
        <div class="form-group row">
            <fieldset>
                <legend>
                    <input type="checkbox" [formControl]="EnableExport" />
                    <span class="uv-checkbox-label">Enable Export</span>
                </legend>
            </fieldset>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div class="uv-row">
                <span class="col-lg-2">Do export from:</span>
                <select class="col-lg-3" [formControl]="ExportOrigin"
                        [ngClass]="{'show-error':SettingsForm.hasError('validExportOrigin'), 'uv-disabled':!EnableExportOrigin}">
                    <option value="agent">Agent</option>
                    <option value="server">Server</option>
                </select>
                <button [disabled]="!isLicenseValid" type="button" style="margin-left: 20px !important;" pButton icon="fa fa-file-o" iconPos="left"
                        label="Export Now (from server)" (click)="ExportNow()"></button>
                <button type="button" pButton label="Test Hudu Connection" [disabled]="!enableTestHuduButton" title="Test/Verify Hudu connection credentials" style="margin-left: 20px !important;"
                        (click)="testHuduConnect()"></button>
            </div>
        </div>
        <hr style="margin-top: 20px; margin-bottom: 20px;" />
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Target Server URL:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="TargetServerApiURL" />
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Target Server API Key:</span>
            <input class="col-lg-3" type="password" pInputText [formControl]="TargetServerApiKey" (keydown)="onPasswordKeyDownHandler($event)" />
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <fieldset>
                <legend>Export Settings</legend>
            </fieldset>
        </div>
        <hr style="margin-top: 20px; margin-bottom: 20px;" />
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">*Company Name:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="CompanyName" [ngClass]="{'show-error':SettingsForm.hasError('validCompany')}" />
        </div>
        @if (SettingsForm.hasError('validCompany')) {
        <div class="form-group row mb-3">
            <span class="col-lg-2"></span>
            <span class="col-lg-3 alert alert-danger">This value is required</span>
        </div>
        }

        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <span class="col-lg-2">Network Name:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="NetworkName" />
        </div>

        <div class="form-group row">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;" [ngClass]="{ 'uv-disabled':!ExportEnabled} ">
                <input type="checkbox" [formControl]="ExportDevices" />
                <span class="uv-checkbox-label">Export Devices</span>
            </div>
        </div>
        <div class="form-group row">
            <div style="margin-left: 70px; margin-top: 10px; margin-bottom: 10px;" [ngClass]="{ 'uv-disabled':!ExportEnabled} ">
                <input type="checkbox" [formControl]="ExportIpAddresses" />
                <span class="uv-checkbox-label">Export IP Addresses</span>
            </div>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;">
                <input type="checkbox" [formControl]="ExportConfigs" />
                <span class="uv-checkbox-label">Export Startup/Running Configs</span>
            </div>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;">
                <input type="checkbox" [formControl]="ExportPasswords" />
                <span class="uv-checkbox-label">Export Passwords</span>
            </div>
        </div>

        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div style="margin-left: 50px; margin-top: 10px; margin-bottom: 10px;">
                <input type="checkbox" [formControl]="ExportMapToLocation" />
                <span class="uv-checkbox-label">Export Map To Location</span>
            </div>
        </div>

        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
            <div class="uv-row">
                <span class="col-lg-2">Map file name:</span>
                <input class="col-lg-3" type="text" pInputText [formControl]="MapFileName" />
            </div>
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled': !ExportEnabled}">
            <div class="uv-row">
                <span for="mapFormat" class="col-lg-2">Map format:</span>
                <div class="col-lg-3">
                    <select class="form-control" [formControl]="MapFileExtension" id="mapFormat">
                        @for (option of mapDropdownOptions; track option) {
                        <option value="{{option}}">{{option}}</option>
                        }
                    </select>
                </div>
            </div>
        </div>

    </form>
</div>
